import { Button } from "@/components/ui/button";

/**
 * État vide réutilisable : icône, titre, description, et action optionnelle.
 * Pensé comme une invitation à agir plutôt qu'un simple constat.
 */
export default function EmptyState({ icon: Icon, title, description, actionLabel, onAction, testId }) {
  return (
    <div className="flex flex-col items-center rounded-xl border border-dashed border-border px-6 py-14 text-center" data-testid={testId}>
      {Icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-secondary text-muted-foreground">
          <Icon size={28} weight="duotone" />
        </div>
      )}
      <p className="font-display text-base font-bold">{title}</p>
      {description && <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {actionLabel && onAction && (
        <Button size="sm" onClick={onAction} className="mt-5 bg-primary hover:bg-primary/90">{actionLabel}</Button>
      )}
    </div>
  );
}
